// モフトレ通信/月選択画面.
import * as React from 'react';
import * as Header from '../constants/Header';
import { MDate, zeroPadding } from '../utils/dateUtil';
import '../css/press.css';
import '../css/month_select.css';
import * as Enumerable from 'linq';
import { SECTION_PRESS_LOCOMO_NAMES, SECTION_PRESS_ADL_NAMES, SKIP_ADL_IDX, TYPE } from '../constants/Training';
import { WEEK_NAMES } from './common/Calendar';
import { MonthlyCountData } from '../utils/MonthlyCountData';
import { Graph, Binding } from '../utils/Graph';

interface PressProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;

  // 前ページのユーザーID.
  match?: any;
}

interface PressState {
}

// 詳細本体.
export default class Press extends React.Component<PressProps, PressState> {
  userId: string;
  yearMonth: string;
  mDate: MDate;

  yearSelected: number;
  monthSelected: number;

  historyDateFlag: boolean[];

  // canvasタグのref.
  refChartLocomo: HTMLCanvasElement | null;
  refChartAdl: HTMLCanvasElement | null;

  // 円グラフの作成に使用.
  trainingCountsLocomo: number[];
  trainingCountsAdl: number[];

  // 例外のときのフラグ.
  isException: boolean = false;

  componentWillMount() {
    document.title = 'モフトレ通信';  

    this.props.headerActions.setPage(Header.PRESS);

    // URLのパラメータ.
    this.userId = this.props.match.params.userId;

    // yyyy-mm.
    this.yearMonth = this.props.match.params.yearMonth;

    // yyyy-mmから生成.
    this.mDate = new MDate(new Date(this.yearMonth));
    this.yearSelected = Number(this.mDate.year);
    this.monthSelected = Number(this.mDate.month);

    // API実行.
    this.runAPI();
  }

  // 円グラフの作成.
  insertPieChart() {
    const menuNumber: number = 0;
    const width: number = 236;
    const height: number = 236;
    const yAxis1Max: number = 30;
    const yAxis2Max: number = 180;

    // Locomo.
    if (!this.refChartLocomo) {
      return;
    }

    const graphLocomo = new Graph();
    let binding: Binding = {
      value: {
        trainingCount_locomo: this.trainingCountsLocomo,
      }
    } as Binding;

    graphLocomo.insertDataCanvasPressPieChartLocomo(
      this.refChartLocomo, binding, menuNumber, width, height, yAxis1Max, yAxis2Max);

    // ADL.
    if (!this.refChartAdl) {
      return;
    }

    const graphADL = new Graph();
    binding = {
      value: {
        trainingCount_adl: this.trainingCountsAdl,
      }
    } as Binding;

    graphADL.insertDataCanvasPressPieChartAdl(
      this.refChartAdl, binding, menuNumber, width, height, yAxis1Max, yAxis2Max);
  }

  getSeasonClassName(selectedMonth: number): string {
    let className: string = '';

    // season
    if (selectedMonth >= 3 && selectedMonth <= 5) {
      className = 'bg_spring';
    } else if (selectedMonth >= 6 && selectedMonth <= 8) {
      className = 'bg_summer';
    } else if (selectedMonth >= 9 && selectedMonth <= 11) {
      className = 'bg_autumn';
    } else if (selectedMonth === 12 || selectedMonth <= 2) {
      className = 'bg_winter';
    }

    return `page_wrapper ${className}`;
  }

  // img以下のパスから画像取得.
  getImage(imagePath: string): string {
    const image: string = require(`../img/${imagePath}`);
    return image;
  }

  getMonthImage(selectedMonth: number): JSX.Element {
    // 0埋めの文字.
    const num: string = zeroPadding(selectedMonth);
    const imgSrc: string = this.getImage(`month_${num}.png`);

    return(
      <img src={imgSrc} alt={`${selectedMonth}月`} />
    );
  }

  getBadge(badgeNum: number): JSX.Element {
    let ptrnAlphabet: string = '';
    let alt: string = '';
    switch (badgeNum) {
      case 1:
        ptrnAlphabet = 'A';
        alt = 'すごい！';
        break;
      case 2:
        ptrnAlphabet = 'B';
        alt = 'そのちょうし！';
        break;
      case 3:
        ptrnAlphabet = 'C';
        alt = 'やったね！';
        break;
      default:
        break;
    } 

    const imgSrc: string = this.getImage(`badge_ptrn${ptrnAlphabet}.png`);
    return (
      <img src={imgSrc} alt={`${alt}`} />
    );
  }

  // 範囲内でAPIを叩く.
  runAPI() {
    // URL部分がyyyy-mmのフォーマットになってるか.
    const regex: RegExp = /^(\d{4})-(0[1-9]|1[0-2])$/;
    const res: boolean = regex.test(this.yearMonth);

    if (res) {
      // この月のみで'yyyy-mm'.
      this.props.moffAPIActions.getMoffDetailData(this.userId, this.yearMonth);
    } else {
      // 正常なフォーマットではないのでユーザ情報のみ取得.
      this.props.moffAPIActions.getMoffDetailData(this.userId, '');
      this.isException = true;
    }
  }

  /**
   * ロコモ用トレーニングの取得.
   * 「◯項目名…N回数」を表示.
   *
   * @param {number[]} trainingCounts
   * @returns {JSX.Element[]}
   * @memberof Press
   */
  getLocomoTrainingName(trainingCounts: number[]): JSX.Element[] {
    // icon_yobou1 ~ icon_yobou9(1開始).
    // ※rangeの第2引数"未満"なのでindexは0~8
    return Enumerable.range(0, 9).toArray().map((_: number, i: number) => {
      const name: string = SECTION_PRESS_LOCOMO_NAMES[i];
      // ◯画像(src/img/icon_yobouN.pkg).
      const imgSrc: string = this.getImage(`icon_yobou${i + 1}.png`);
      return (
        <li key={`icon_yobou_${i}`} className="list">
          <img src={imgSrc} className="icon" />
          {name}&hellip;<span>{trainingCounts[i]}</span>回
        </li>);
      }
    );
  }

  // ADL用トレーニングの取得.
  getADLTrainingName(trainingCounts: number[]): (null|JSX.Element)[] {
    // icon_daily1~icon_daily5(1開始).
    return Enumerable.range(0, 7).where(i => SKIP_ADL_IDX.indexOf(i) === -1) // スキップする以外.
      // item(0~7の4,5はスキップで0,1,2,3,6), i(0~4)
      .toArray().map((item: number, i: number) => {
      // 名前は欠番は飛ばすのでitemを使用する.
      const name: string = SECTION_PRESS_ADL_NAMES[item];

      // アイコンは欠番になってないのでiを使用する.
      const imgSrc: string = this.getImage(`icon_daily${i + 1}.png`);

      return (
        <li key={`icon_daily_${i}`} className="list">
          <img src={imgSrc} className="icon" />
          {name}&hellip;<span>{trainingCounts[item]}</span>回
        </li>);
      }
    );
  }

  // カレンダーの生成.
  createCalender(): JSX.Element[] {
    const calender = this.mDate.makeCalendar(this.yearSelected, this.monthSelected);

    return calender.map((week: {day: number|string}[], index: number) => {
      const key = `calender${index}`;
      return (
      <tr key={key}>
      {
        week.map((day: {day: number|string}, weekIndex: number) => {
          const keyWeek = `calennderWeek${index}-${weekIndex}`;

          // ないのはスペース.
          if (!day.day) {
            return <td key={keyWeek} />;
          }

          const num: string = zeroPadding(day.day);
          let className: string = '';
          if (this.historyDateFlag[day.day]) {
            className = `done day_${num}`;
          } else {
            className = `day_${num}`;
          }

          return <td className={className} key={keyWeek} />;
        })}
      </tr>);
    });
  }

  // memoの右下に出るアイコン.
  getMemoIcon(selectedMonth: number): JSX.Element {
    const num: string = zeroPadding(selectedMonth);
    const imgSrc: string = this.getImage(`icon_${num}.png`);
    return <img src={imgSrc} className="ft_memo_icon" />;
  }

  renderCSS(): JSX.Element {
    return (
      <style type="text/css">
        {/* 回数,トレーニング項目,カレンダーの行間 */}
        {'body { line-height: 1; background: none; }'}
        {/* 余白消す. */}
        {'#wrapper { padding: 0; border: 0; margin: 0; min-height: 0; }'}
        {'#wrapper .contentIn { padding: 0; border: 0; margin: 0; }'}
        {/* 縦印刷, 日付・title名ヘッダの余白 */}
        {'@media print{@page {size: 210mm 297mm; margin-top: 40px;}}'}
        {'@media print{#wrapper { margin-top: 0; } header { display: none; }'}
      </style>
    );
  }

  render() {
    return this.props.moffAPI.Loaded ?
      // ロード後.
      this.renderBody()
      :
      // ロード中もCSSの背景が出ないように使用する.
      this.renderCSS();
  }

  componentDidUpdate() {
    // 更新後.
    this.insertPieChart();
  }

  renderBody(): JSX.Element {
    const user: any = this.props.moffAPI.result.user;

    let badgeLocomo: number = 0;
    let badgeADL: number = 0;
    let maxTrainingIdLocomo: number = -1;
    let maxTrainingIdAdl: number = -1;
    let maxTrainingCountLocomo: number = 0;
    let maxTrainingCountAdl: number = 0;

    if (this.props.moffAPI.result.locomo !== null && this.props.moffAPI.result.adl !== null) {
      // Locomoのモフトレデータ取得
      const monthlyCountDataLocomo: MonthlyCountData = new MonthlyCountData(TYPE.Locomo);
      const moffTrainingDataLocomo = monthlyCountDataLocomo.getMoffTrainingCounts(this.props.moffAPI.result.locomo);

      // 取得したデータから変数へセット.
      badgeLocomo = moffTrainingDataLocomo.badge;
      maxTrainingIdLocomo = moffTrainingDataLocomo.maxTrainingId;
      this.trainingCountsLocomo = moffTrainingDataLocomo.trainingCountArr;
      maxTrainingCountLocomo = moffTrainingDataLocomo.maxTrainingCount;
      const historyDateFlagLocomo: boolean[] = moffTrainingDataLocomo.historyDateFlag;

      // 日常生活動作トレーニング(ADL)のモフトレデータ取得.
      const monthlyCountDataAdl: MonthlyCountData = new MonthlyCountData(TYPE.ADL);
      const moffTrainingDataAdl = monthlyCountDataAdl.getMoffTrainingCounts(this.props.moffAPI.result.adl);

      // 取得したデータから変数へセット.
      badgeADL = moffTrainingDataAdl.badge;
      maxTrainingIdAdl = moffTrainingDataAdl.maxTrainingId;
      this.trainingCountsAdl = moffTrainingDataAdl.trainingCountArr;
      maxTrainingCountAdl = moffTrainingDataAdl.maxTrainingCount;
      const historyDateFlagAdl: boolean[] = moffTrainingDataAdl.historyDateFlag;

      // LocomoとADLのgetMoffTrainingCountsが完了してから取得する(両方のデータのため).
      // 2つの配列を論理和でコンバイン.
      this.historyDateFlag = Enumerable.from(historyDateFlagLocomo)
        .select((item, idx: number) => item || historyDateFlagAdl[idx])
        .toArray();
    }

    return (
      <div className={this.getSeasonClassName(this.monthSelected)}>
        {this.renderCSS()}
        <div className="page_inner">
          <div className="page_hd">
            <div className="hd_title">
              <img src={`${this.getImage('cmn_title.png')}`} alt="モフトレ通信" />
            </div>
            <div className="hd_month">
              {this.isException ? null : this.getMonthImage(this.monthSelected)}
            </div>
            <div className="hd_username">
              <img src={`${this.getImage('hd_bg.png')}`} />
              <div className="hd_username_inner">
                <span>{user.user_name}</span>
                <span className="sama">様</span>
              </div>
            </div>
          </div>
          {/* ロコモ予防トレーニング */}
          <div className="page_bd yobou row">
            <img src={`${this.getImage('bd_bg.png')}`} />
            <div className="bd_data column">
              <div className="bd_title">
                <img src={`${this.getImage('bd_ttl_yobou.png')}`} alt="ロコモ予防トレーニング" />
              </div>
              {
                // 円グラフの表示処理.
                badgeLocomo > 0 ?
                  (<div className="bd_graph">
                    <canvas
                      ref={(chart) => { this.refChartLocomo = chart; }}
                      width="236"
                      height="236"
                    />
                    </div>
                  )
                  :
                  (null)
              }
              <div className="bd_list">
              {
                // 各項目の回数の表示処理.
                badgeLocomo === 0 ?
                  (<img src={`${this.getImage('badge-0.png')}`} alt="おやすみ" />)  
                  :
                  (<ul className="bd_list_inner">
                    {this.getLocomoTrainingName(this.trainingCountsLocomo)}
                  </ul>)
              }
              </div>
            </div>
            {
              // BEST1メダルの表示処理.
              badgeLocomo > 0 ?
                <div className="bd_result column">
                  <div className="bd_badge">
                    {this.getBadge(badgeLocomo)}
                  </div>
                  <div className="bd_label">
                    <span>{`${SECTION_PRESS_LOCOMO_NAMES[maxTrainingIdLocomo]}`}</span>
                  </div>
                  <div className="bd_count">
                    <div className="bd_count_inner">
                      <span className="num">{maxTrainingCountLocomo}</span>
                      <span className="kai">回</span>
                    </div>
                  </div>
                </div>
              : (null)
            }
          </div>
          {/* 日常生活動作トレーニング */}
          <div className="page_bd adl row">
            <img src={`${this.getImage('bd_bg.png')}`} />
            <div className="bd_data column">
              <div className="bd_title">
                <img src={`${this.getImage('bd_ttl_daily.png')}`} alt="日常生活動作トレーニング" />
              </div>
              {
                badgeADL > 0 ?
                (<div className="bd_graph">
                  <canvas
                    ref={(chart) => { this.refChartAdl = chart; }}
                    width="236"
                    height="236"
                  />
                </div>)
                : (null)
              }
              <div className="bd_list">
                {
                  badgeADL === 0 ?
                  (<img src={`${this.getImage('badge-0.png')}`} alt="おやすみ" />)
                  :
                  (<ul className="bd_list_inner">
                    {this.getADLTrainingName(this.trainingCountsAdl)}
                  </ul>)
                }
              </div>
            </div>
            {
              badgeADL > 0 ?
                <div className="bd_result column">
                  <div className="bd_badge">
                    {this.getBadge(badgeADL)}
                  </div>
                  <div className="bd_label">
                    <span>{`${SECTION_PRESS_ADL_NAMES[maxTrainingIdAdl]}`}</span>
                  </div>
                  <div className="bd_count">
                    <div className="bd_count_inner">
                      <span className="num">{maxTrainingCountAdl}</span>
                      <span className="kai">回</span>
                    </div>
                  </div>
                </div>
              : (null)
            }
          </div>
          {/* カレンダー */}
          <div className="page_ft row">
            <div className="ft_calendar calendar column">
              <img src={`${this.getImage('cal_title.png')}`} alt="おやすみ" />
              <table id="press_calendar">
                <thead>
                  <tr>
                    {
                      WEEK_NAMES.map((week: string, i: number) => {
                        return <th key={`week_${i}`}>{week}</th>;
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  {this.isException ? null : this.createCalender()}
                </tbody>
              </table>
            </div>
            {/* メモ */}
            <div className="ft_memo column">
              <img src={`${this.getImage('ft_memo.png')}`} />
              <p className="ft_text">
                {this.isException ? null : this.getMemoIcon(this.monthSelected)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Press.tsx